// Copyright (c) .NET Foundation. All rights reserved.
// Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.

// Version token that will be replaced by the prepack command
/** The version of the SignalR Message Pack protocol library. */
export const VERSION = "0.0.0-DEV_BUILD";

export { MessagePackHubProtocol } from "./MessagePackHubProtocol";
